import React from 'react';
import Button from '@/UIlibrary/Button/Button';
import TextArea from '@/UIlibrary/TextArea/TextArea';
import { useTranslations } from 'use-intl';

interface KnowledgeBaseTabProps {
	markdown: string;
	isSaving: boolean;
	isFetching: boolean;
	onMarkdownChange: (value: string) => void;
	onSave: () => void;
}

export const KnowledgeBaseTab: React.FC<KnowledgeBaseTabProps> = ({
	markdown,
	isSaving,
	isFetching,
	onMarkdownChange,
	onSave
}) => {
	const t = useTranslations('ManageAgents');

	return (
		<div className="w-full space-y-6 mt-4">
			<div className="w-full">
				<TextArea
					name="knowledgeBase"
					id="knowledgeBase"
					label={t('KnowledgeBaseContent')}
					value={markdown}
					onChange={(e) => onMarkdownChange(e.target.value)}
					disabled={isSaving || isFetching}
					rows={20}
					placeholder={t('KnowledgeBasePlaceholder')}
					loading={isFetching}
				/>
			</div>
			<div className="w-full flex justify-end">
				<Button
					onClick={onSave}
					color="primary"
					size="auto"
					label={isSaving ? t('Saving') : t('SaveKnowledgeBase')}
					disabled={!markdown.trim() || isSaving || isFetching}
					loading={isSaving}
				/>
			</div>
		</div>
	);
};
